import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import { DynamicComponents, dynamicModuleModel } from '~/widgets/DynamicModule'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle identifier={STATIC_IDENTIFIERS.HOME} fallbackKey='home' />
  )
}

const emptySkin = era.skin('shared/ui/components/NoContentBlock')

HomePage.displayName = 'HomePage'
export function HomePage(): JSX.Element {
  const [shouldShowGlobalEmptyState, isContentLoading] = useUnit([
    dynamicModuleModel.$shouldShowGlobalEmptyState,
    dynamicModuleModel.$isModuleContentLoading,
  ])

  if (shouldShowGlobalEmptyState) {
    return (
      <ui.PageWrapper className='flex-column catalog-empty'>
        <ui.RenderSkin from={emptySkin} name='catalogEmptyPage' />
      </ui.PageWrapper>
    )
  }

  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={isContentLoading}>
        <DynamicComponents />
      </Skeleton>
    </ui.PageWrapper>
  )
}
